import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCheckout } from '../context/CheckoutContext';

const TestCheckout = () => {
  const navigate = useNavigate();
  const { updateCheckoutData } = useCheckout();
  
  useEffect(() => {
    // Update checkout data in context with all required information
    updateCheckoutData({
      productName: 'Nosferatu',
      productId: '1',
      selectedSize: '7 1/2',
      price: 750.00,
      shippingAddress: {
        fullName: 'John Doe',
        email: 'john.doe@example.com',
        phone: '+1234567890',
        addressLine1: '123 Main St',
        addressLine2: 'Apt 4B',
        city: 'New York',
        state: 'NY',
        postalCode: '10001',
        country: 'United States'
      },
      shipping: {
        option: {
          carrier: 'DHL Express',
          service: 'International Priority',
          estimatedDelivery: '3-5 business days'
        },
        cost: 25.00
      }
    });
    
    // Navigate directly to payment page
    navigate('/checkout/payment');
  }, [navigate, updateCheckoutData]);
  
  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-light">Redirecting to payment page...</p>
    </div>
  );
};

export default TestCheckout;
